// Chakra imports
import { Box, Flex } from "@chakra-ui/react";
import EmployeesTable from "views/company/employees/components/EmployeesTable";
import React from "react";
import OrgCompanySelector, { isOrgAdmin } from "../../../components/orgCompanySelector/OrgCompanySelector";

export default function Employees() {
  const [selectedCompanyId, setSelectedCompanyId] = React.useState(null);
  const showOrgSelector = isOrgAdmin();

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      {showOrgSelector && (
        <Flex mb="16px" px="10px">
          <OrgCompanySelector
            selectedCompanyId={selectedCompanyId}
            onChange={setSelectedCompanyId}
          />
        </Flex>
      )}
      <EmployeesTable selectedCompanyId={selectedCompanyId} />
    </Box>
  );
}
